import React from 'react';
import {WeChatMessageTemplateDto} from "../../../../../modules/wechat/dto/WeChatMessageTemplateDto";
import {FormattedMessage, useIntl} from "react-intl";
import {Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";

import {useConfirm} from "material-ui-confirm";

export type SearchResultProps = {
    searchResult: Array<WeChatMessageTemplateDto>;
    onClickDelete: (record: WeChatMessageTemplateDto) => void;
    onClickModify: (record: WeChatMessageTemplateDto) => void;
};

const SearchResult: React.FC<SearchResultProps> = (props) => {
    const intl = useIntl();

    const confirm = useConfirm();

    const _handleClickDetail = (record: WeChatMessageTemplateDto) => {
        props.onClickModify(record);
    };

    const _handleClickDelete = (record: WeChatMessageTemplateDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(() => {
                console.log('ok');
                props.onClickDelete(record);
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell><FormattedMessage id={'WECHAT_MESSAGE_TEMPLATE_CODE'}/></TableCell>
                    <TableCell><FormattedMessage id={'WECHAT_MESSAGE_TEMPLATE_NAME'}/></TableCell>
                    <TableCell><FormattedMessage id={'WECHAT_MESSAGE_TEMPLATE_TEMPLATE_ID'}/></TableCell>
                    <TableCell><FormattedMessage id={'WECHAT_MESSAGE_TEMPLATE_TEMPLATE_TITLE'}/></TableCell>
                    <TableCell><FormattedMessage id={'COMMON_ACTION'}/></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.searchResult.map((item, index) => (
                    <TableRow key={index}>
                        <TableCell>
                            {item.code}
                        </TableCell>
                        <TableCell>
                            {item.name}
                        </TableCell>
                        <TableCell>
                            {item.templateId}
                        </TableCell>
                        <TableCell>
                            {item.templateTitle}
                        </TableCell>
                        <TableCell>
                            <Button size="small" onClick={() => _handleClickDetail(item)}><FormattedMessage
                                id={'COMMON_MODIFY'}/></Button>
                            <Button size="small" onClick={() => _handleClickDelete(item)}><FormattedMessage
                                id={'COMMON_DELETE'}/></Button>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default SearchResult;
